import {
  COMPANY_ACCOUNT_KINDS,
  COMPANY_ACCOUNT_KIND_LABELS,
  COMPANY_ACCOUNT_STATUSES,
  COMPANY_ACCOUNT_STATUS_LABELS,
  type CompanyAccountListQuery,
} from '@chukua/common';
import { Tag, type TableColumnsType } from 'antd';
import type { ReactNode } from 'react';
import type { ListQueryControls } from '../../../shared/hooks/use-list-query';
import type { CompanyAccountView } from '../company-accounts.api';

interface BuildCompanyAccountColumnsArgs {
  list: Pick<ListQueryControls<CompanyAccountListQuery>, 'sortOrderFor' | 'filteredValueFor'>;
  actions: (account: CompanyAccountView) => ReactNode;
}

/** A column's `key` is its sort field or filter param in `companyAccountListQuerySchema`. */
export function buildCompanyAccountColumns({ list, actions }: BuildCompanyAccountColumnsArgs): TableColumnsType<CompanyAccountView> {
  return [
    {
      title: 'Name',
      key: 'name',
      sorter: true,
      sortOrder: list.sortOrderFor('name'),
      render: (_, account) => <span className="font-medium">{account.name}</span>,
    },
    {
      title: 'Kind',
      key: 'kind',
      sorter: true,
      sortOrder: list.sortOrderFor('kind'),
      filters: COMPANY_ACCOUNT_KINDS.map((kind) => ({ text: COMPANY_ACCOUNT_KIND_LABELS[kind], value: kind })),
      filteredValue: list.filteredValueFor('kind'),
      render: (_, account) => COMPANY_ACCOUNT_KIND_LABELS[account.kind],
    },
    { title: 'Details', key: 'detail', render: (_, account) => account.detail },
    {
      title: 'Status',
      key: 'status',
      filters: COMPANY_ACCOUNT_STATUSES.map((status) => ({ text: COMPANY_ACCOUNT_STATUS_LABELS[status], value: status })),
      filteredValue: list.filteredValueFor('status'),
      render: (_, account) => <Tag color={account.status === 'active' ? 'green' : undefined}>{COMPANY_ACCOUNT_STATUS_LABELS[account.status]}</Tag>,
    },
    { title: '', key: 'actions', align: 'right', render: (_, account) => actions(account) },
  ];
}
